import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Database, Mail, Trash2, Eye } from 'lucide-react';
import EditorCredit from '../../components/EditorCredit';

export default function Confidentialite() {
  return (
    <div className="min-h-screen bg-white" data-testid="confidentialite-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-12 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0F172A] mb-8">
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>

        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-lg grid place-items-center" style={{ background: 'rgba(0,82,255,0.1)' }}>
            <Shield className="w-5 h-5" style={{ color: '#0052FF' }} />
          </div>
          <h1 className="font-display text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A]">Politique de confidentialité</h1>
        </div>
        <p className="text-sm text-[#475569] mb-10">Dernière mise à jour : juin 2026 · Conforme RGPD</p>

        <div className="space-y-8 text-sm leading-relaxed">
          <section className="card !bg-blue-50/50 !border-blue-200">
            <h2 className="font-display text-base font-bold text-[#0F172A] mb-2 flex items-center gap-2">
              <Eye className="w-4 h-4 text-blue-600" /> En résumé
            </h2>
            <ul className="space-y-1.5 text-[#0F172A] text-xs">
              <li>• Nous collectons uniquement les données nécessaires au fonctionnement du service</li>
              <li>• Vos données ne sont jamais vendues à des tiers</li>
              <li>• Vous pouvez exporter ou supprimer vos données à tout moment</li>
              <li>• Tous les paiements sont sécurisés par Stripe (PCI-DSS Level 1)</li>
              <li>• Les mots de passe sont hashés (bcrypt) et jamais stockés en clair</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3 flex items-center gap-2">
              <Database className="w-5 h-5 text-[#94A3B8]" /> 1. Données collectées
            </h2>
            <p className="text-[#0F172A] mb-3">Pour fournir le service, nous collectons :</p>
            <ul className="list-disc list-inside text-[#0F172A] space-y-1 pl-2">
              <li><strong>Données d'inscription</strong> : nom, prénom, email, mot de passe (hashé)</li>
              <li><strong>Données de l'association</strong> : nom, type, logo, couleurs, formules</li>
              <li><strong>Données des membres</strong> : nom, email, téléphone, formule d'adhésion, statut</li>
              <li><strong>Données de paiement</strong> : géré par Stripe — nous ne stockons aucune donnée carte bancaire</li>
              <li><strong>Données techniques</strong> : adresse IP, navigateur, OS (logs serveur 30 jours)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3 flex items-center gap-2">
              <Lock className="w-5 h-5 text-[#94A3B8]" /> 2. Finalités du traitement
            </h2>
            <p className="text-[#0F172A]">Vos données sont utilisées pour :</p>
            <ul className="list-disc list-inside text-[#0F172A] mt-2 space-y-1 pl-2">
              <li>Permettre l'accès et l'utilisation de votre compte</li>
              <li>Gérer les paiements et l'envoi de factures</li>
              <li>Envoyer les emails transactionnels (vérification, billet, relance)</li>
              <li>Assurer la sécurité et prévenir la fraude</li>
              <li>Améliorer le service (statistiques anonymisées)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">3. Base légale</h2>
            <p className="text-[#0F172A]">Conformément à l'article 6 du RGPD, le traitement repose sur :</p>
            <ul className="list-disc list-inside text-[#0F172A] mt-2 space-y-1 pl-2">
              <li><strong>Exécution du contrat</strong> : pour les données nécessaires au service</li>
              <li><strong>Consentement</strong> : pour les emails marketing (opt-in explicite)</li>
              <li><strong>Obligation légale</strong> : conservation des factures (10 ans)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">4. Sous-traitants</h2>
            <p className="text-[#0F172A]">Pour fournir le service, nous utilisons :</p>
            <ul className="list-disc list-inside text-[#0F172A] mt-2 space-y-1 pl-2">
              <li><strong>Stripe</strong> (paiements) — Irlande, conforme RGPD</li>
              <li><strong>SendGrid / Twilio</strong> (emails transactionnels) — USA, Privacy Shield + SCC</li>
              <li><strong>Infrastructure cloud sécurisée</strong> (hébergement) — Conforme RGPD, serveurs UE</li>
              <li><strong>Anthropic</strong> (agents IA pour relances) — USA, SCC</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">5. Durée de conservation</h2>
            <ul className="list-disc list-inside text-[#0F172A] space-y-1 pl-2">
              <li>Compte actif : durée de l'abonnement</li>
              <li>Compte clos : suppression sous 30 jours (sauf demande explicite)</li>
              <li>Factures : 10 ans (obligation légale)</li>
              <li>Logs serveur : 30 jours</li>
              <li>Cookies techniques : 13 mois maximum</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3 flex items-center gap-2">
              <Trash2 className="w-5 h-5 text-[#94A3B8]" /> 6. Vos droits
            </h2>
            <p className="text-[#0F172A] mb-3">Conformément au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc list-inside text-[#0F172A] space-y-1 pl-2">
              <li><strong>Accès</strong> : obtenir une copie de vos données</li>
              <li><strong>Rectification</strong> : corriger des données inexactes</li>
              <li><strong>Effacement</strong> : demander la suppression de vos données</li>
              <li><strong>Portabilité</strong> : récupérer vos données dans un format standard (JSON, CSV)</li>
              <li><strong>Opposition</strong> : refuser un traitement (ex: marketing)</li>
              <li><strong>Limitation</strong> : suspendre temporairement un traitement</li>
            </ul>
            <p className="text-[#0F172A] mt-3">
              Pour exercer vos droits, écrivez à <a href="mailto:market46.d@gmail.com" className="text-blue-600 hover:underline font-semibold">market46.d@gmail.com</a>.
              Réponse sous 30 jours maximum.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">7. Cookies</h2>
            <p className="text-[#0F172A]">
              AssoPerf utilise uniquement des cookies <strong>strictement nécessaires</strong> au fonctionnement
              (authentification, préférences). Aucun cookie publicitaire ou de tracking tiers n'est utilisé.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3">8. Sécurité</h2>
            <p className="text-[#0F172A]">Mesures techniques mises en place :</p>
            <ul className="list-disc list-inside text-[#0F172A] mt-2 space-y-1 pl-2">
              <li>Chiffrement HTTPS (TLS 1.3) pour toutes les communications</li>
              <li>Mots de passe hashés avec bcrypt (10 rounds)</li>
              <li>Tokens JWT avec rotation et expiration</li>
              <li>Sauvegardes quotidiennes chiffrées de la base de données</li>
              <li>Surveillance continue et alertes en cas d'activité anormale</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-bold text-[#0F172A] mb-3 flex items-center gap-2">
              <Mail className="w-5 h-5 text-[#94A3B8]" /> 9. Contact DPO
            </h2>
            <p className="text-[#0F172A]">
              Pour toute question sur le traitement de vos données :{' '}
              <a href="mailto:market46.d@gmail.com" className="text-blue-600 hover:underline font-semibold">market46.d@gmail.com</a>
            </p>
            <p className="text-[#0F172A] mt-2">
              Éditeur : <strong>Osez Studio</strong> · SAS Market & Développement · 46100 Figeac
            </p>
            <p className="text-[#0F172A] mt-2">
              Vous pouvez également déposer une réclamation auprès de la CNIL :{' '}
              <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">cnil.fr/plaintes</a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#E2E8F0] flex flex-wrap gap-4 text-xs text-[#475569]">
          <Link to="/mentions-legales" className="hover:text-[#0F172A]">Mentions légales</Link>
          <Link to="/cgu" className="hover:text-[#0F172A]">CGU</Link>
          <Link to="/" className="hover:text-[#0F172A]">Accueil</Link>
        </div>
      </div>
      <EditorCredit variant="light" />
    </div>
  );
}
